import { aggregateScores, type ScoreRecord } from "../store/scores";
import { el } from "./dom";

/** Render the Results drawer section into `container` (replacing its children). */
export function renderResults(container: HTMLElement, records: ScoreRecord[]): void {
  container.replaceChildren();
  const aggregates = aggregateScores(records);
  if (aggregates.length === 0) {
    container.append(
      el("p", { class: "muted", textContent: "No results yet — play a song in scored mode." }),
    );
    return;
  }
  const pct = (x: number) => `${Math.round(x * 100)}%`;
  for (const a of aggregates) {
    const runs = `${a.runs} run${a.runs === 1 ? "" : "s"}`;
    const row = el("div", { class: "result-row" });
    row.append(
      el("div", { class: "result-title", textContent: a.title }),
      el("div", {
        class: "result-meta",
        textContent: `Best ${pct(a.bestAccuracy)} · Median ${pct(a.medianAccuracy)} · Latest ${pct(a.latestAccuracy)} · ${runs}`,
      }),
    );
    container.append(row);
  }
}
